import React from "react";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { IconCalendar, IconBell } from "@tabler/icons-react";
import { UpcomingFamilyReminder } from "@/types/reminders";
import { formatReminderDate, formatTime } from "@/utils/date-utils";
import styles from "./UpcomingReminders.module.css";

interface UpcomingRemindersProps {
  reminders: UpcomingFamilyReminder[];
}

const UpcomingReminders: React.FC<UpcomingRemindersProps> = ({ reminders }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!reminders || reminders.length === 0) return null;

  return (
    <div className={styles.section} data-upcoming-reminders>
      <div className={styles.headerRow}>
        <h2 className={styles.title}>
          {t("dashboard.upcomingReminders.title")}
        </h2>
        <button
          type="button"
          className={styles.seeAll}
          onClick={() =>
            navigate("/profile/family/reminders-overview", {
              state: { backUrl: "/" },
            })
          }
        >
          {t("dashboard.upcomingReminders.seeAll")}
        </button>
      </div>
      <div className={styles.card}>
        {reminders.map((reminder, index) => (
          <div
            key={reminder.id}
            className={`${styles.item} ${
              index < reminders.length - 1 ? styles.itemDivider : ""
            }`}
          >
            <span className={styles.iconWrapper}>
              <IconCalendar size={24} color="#4C189A" />
            </span>
            <div className={styles.itemContent}>
              <p className={styles.itemMessage}>
                <Trans
                  i18nKey="dashboard.upcomingReminders.genericMessage"
                  values={{ name: reminder.memberName }}
                  components={{ b: <b /> }}
                />
              </p>
              <div className={styles.itemDetail}>
                <span className={styles.itemTitle}>{reminder.reminderFor}</span>
                {reminder.eventDate && (
                  <span className={styles.itemDate}>
                    <IconBell size={16} color="#D47F3A" />
                    {formatReminderDate(reminder.eventDate)}{" "}
                    {t("dashboard.upcomingReminders.at")}{" "}
                    {formatTime(reminder.eventDate)}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingReminders;
